import { ModalBody } from "@chakra-ui/react";
import { ModalLegacyProps } from "@looksrare/uikit";
import { useTranslation } from "next-i18next";
import { Button } from "uikit";

export const CompleteView = ({ onClose }: { onClose: ModalLegacyProps["onClose"] }) => {
  const { t } = useTranslation();
  const handleClose = () => {
    // clear relevant query cache, close modal
    onClose();
  };
  return (
    <ModalBody>
      <Button width="100%" onClick={handleClose}>
        {t("Got it")}
      </Button>
    </ModalBody>
  );
};
